import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getInfoSelects() {
    return axios.get(API_URL+'/v1/DataforSelectsv2')
  }

export function getInfoSelectsGlobal(id:number) {
    return axios.get(API_URL+'/v1/DataforSelectsv2?tenantId='+id)
  }

export function getListPermisos() {
  return axios.get(API_URL+'/v1/suscription/listPermission')
}

export function getListPermisostenant(tenant:any) {
  return axios.get(API_URL+'/v1/suscription/listPermission?tenantId='+tenant)
}